module.exports = __webpack_public_path__ + "static/img/en2.f1c7c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en2.jpg
// module id = IPYo
// module chunks = 1